import { createRouter, createWebHistory } from 'vue-router'

import ProfilePage from '@/components/ProfilePage.vue'

import AboutPage from '@/components/AboutPage.vue'

import ProjectPage from '@/components/ProjectPage.vue'

import ContactPage from '@/components/ContactPage.vue'


const routes =
    [
        { path: '/new', component: ProfilePage },

        { path: '/about', component: AboutPage },

        { path: '/', component: ProjectPage },

        { path: '/contact', component: ContactPage }
    ];

const router = createRouter({

    history: createWebHistory(),

    routes,
});

export default router;